const magazineGenerateShareSnsLink = () => {
    const snsLinks = [...document.querySelectorAll('.jsMagazineGenerateShareSnsLink a')];

    if(!snsLinks) return;

    const url = encodeURIComponent(location.href);
    const title = encodeURIComponent(document.title);

    snsLinks.forEach(link => {
        const type = (snsName) => link.classList.contains(snsName);

        if(type('facebook')) link.href = `https://www.facebook.com/sharer.php?u=${url}`;
        if(type('twitter')) link.href = `https://twitter.com/share?text=${title}&url=${url}`;
        if(type('line')) link.href = `https://line.me/R/msg/text/?${title}%20${url}`;
    });
}

export { magazineGenerateShareSnsLink };
